import React, { useEffect, useState } from "react";
import { Flex, Spinner } from "@chakra-ui/react";
import { StudioEditor } from "./Editor";
import { StudioContextProvider } from "./studioContext";
import { ServicesProvider } from "./servicesContext";
export const Studio = ({ layoutService, layoutItems, selectedLayoutItemId, widgets, screenWidth, screenHeight, isLocked, loadedFonts, onUpdateScreenWidth, onUpdateScreenHeight, pageService, pageList, showAnimations, }) => {
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(true);
        const promises = Promise.all(widgets
            .filter((widget) => widget.load !== null)
            .map((widget) => widget.load()));
        promises
            .catch((reason) => console.log(reason))
            .finally(() => setIsLoading(false));
        setTimeout(() => {
            setIsLoading(false);
            console.log(promises);
        }, 10000);
    }, [widgets.map((widget) => widget.id).join(",")]);
    return isLoading ? (React.createElement(Spinner, null)) : (React.createElement(StudioContextProvider, { layoutItems: layoutItems, selectedLayoutItemId: selectedLayoutItemId, pageList: pageList, widgets: widgets, screenWidth: screenWidth, screenHeight: screenHeight, isLocked: isLocked, loadedFonts: loadedFonts, onUpdateScreenWidth: onUpdateScreenWidth, onUpdateScreenHeight: onUpdateScreenHeight, showAnimations: showAnimations },
        React.createElement(ServicesProvider, { layoutService: layoutService, pageService: pageService },
            React.createElement(Flex, { width: "100%", height: "100%", direction: "column" },
                React.createElement(StudioEditor, null)))));
};
